import angular from 'angular';
import uiRouter from 'angular-ui-router';
import loansDetailSendDocumentationComponent from './loansDetailSendDocumentation.component';

let loansDetailSendDocumentationModule = angular.module('loansDetailSendDocumentation', [
  uiRouter,
])

.component('loansDetailSendDocumentation', loansDetailSendDocumentationComponent)

.name;

export default loansDetailSendDocumentationModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansDetail/loansDetailSendDocumentation/loansDetailSendDocumentation.js